import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Subprocessors } from '/screens/';

export default function SubprocessorsPage() {
  return (
    <>
      <Head>
        <meta name="keywords" content="Sub-Processors" />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="List of Sub-Processors"
        description="List of Sub-Processors at Loadsmart | Loadsmart"
        canonical="https://loadsmart.com/subprocessors/"
        openGraph={{
          url: 'https://loadsmart.com/subprocessors/',
        }}
      />
      <Subprocessors />
    </>
  );
}
